import { Provider } from 'react-redux'
import AppRouter from './routes/AppRouter'
import store from './store/store'
import { NotificationProvider } from './components/notification/NotificationProvider'
import { useAppDispatch, useAppSelector } from './store/hook'
import {
  initializeAuth,
  selectAuthError,
  selectAuthLoading,
  selectCurrentUser,
  selectIsAuthenticated,
  selectShouldFetchUser
} from './store/slices/authSlice'
import { useGetCurrentUserMutation } from './store/api/authApi'
import { useEffect } from 'react'

// Create a separate component for the app logic that uses Redux hooks
function AppContent() {
  const dispatch = useAppDispatch()
  const user = useAppSelector(selectCurrentUser)
  const isAuthenticated = useAppSelector(selectIsAuthenticated)
  const isLoading = useAppSelector(selectAuthLoading)
  const shouldFetchUser = useAppSelector(selectShouldFetchUser)
  console.log(shouldFetchUser);
  
  const authError = useAppSelector(selectAuthError)

  const [getCurrentUser] = useGetCurrentUserMutation()

  useEffect(() => {
    // Initialize auth state from localStorage
    dispatch(initializeAuth())
  }, [dispatch])

  useEffect(() => {
    // Only fetch user if we don't have user data in localStorage or state
    if (shouldFetchUser) {
      getCurrentUser()
        .unwrap()
        .catch((error) => {
          console.error('Failed to fetch current user:', error)
          // Handle error if needed - the authSlice will handle auth errors
        })
    }
  }, [shouldFetchUser, getCurrentUser])

  // Optional: Add a loading state while initializing
  if (isLoading) {
    return <div>ກຳລັງໂຫຼດ...</div>
  }

  return (
    <NotificationProvider>
      <AppRouter />
    </NotificationProvider>
  )
}

// Main App component that provides the Redux store
function App() {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  )
}

export default App